const isIllustration = (url: string) => /^\/api\/illustrations\/[^/?#]+$/.test(url);
export function imageSource(url: string, width = 640) {
  return isIllustration(url) ? `${url}?w=${width}` : url;
}
export function imageSourceSet(url: string) {
  return isIllustration(url) ? [320, 640, 960, 1280].map(width => `${imageSource(url, width)} ${width}w`).join(", ") : undefined;
}
